export default "__VITE_ASSET__ddb8dcad__"